import { React, useState } from "react";
import "./peoplelist.css";
import { InputGroup, Form, Button } from "react-bootstrap";

function PeopleListInput(props) {
  const [count, setCount] = useState(0);

  const handleInputChange = (e) => {
    const listString = e.target.value;
    const list = listString
      .split("\n")
      .filter((str) => {
        return str.trim().length;
      })
      .map((str) => {
        return str.trim();
      });

    setCount(list.length);
    props.onChange(list);
  };

  return (
    <Form>
      <Form.Group className="mb-3 small-input-group" controlId="exampleForm.ControlTextarea1">
        <Form.Label className="subtitle">Number of participants: {count}</Form.Label>
        <Form.Control
          className="text-area"
          as="textarea"
          onChange={handleInputChange}
          rows={3}
          placeholder="Each name must be on a new line..."
        />
      </Form.Group>
    </Form>
  );
}

// const PeopleListInput = (props) => {
//   return (
//     <InputGroup className="mb-3 small-input-group">
//       <InputGroup.Text>First and last name</InputGroup.Text>
//       <Form.Control
//         aria-label="First name"
//         onChange={(e) => {
//           console.log(e.target.value);
//         }}
//       />
//       <Form.Control
//         aria-label="Last name"
//         onChange={(e) => {
//           console.log(e.target.value);
//         }}
//       />
//       <Button variant="primary">ADD</Button>
//     </InputGroup>
//   );
// };

export default PeopleListInput;
